import React from 'react'
import { Link } from 'gatsby'
import Img from "gatsby-image/withIEPolyfill";
import moment from "moment";

import styles from './article-preview.module.css'

export default ({ article }) => {
  moment.locale("fr-ca");
  return (
    <Link to={`/blog/${article.slug}/`}>
      <div className={styles.preview}>
        <div className={styles.articleImg}>
          <Img
            fluid={article.heroImage.fluid}
            objectFit="cover"
            objectPosition="50% 50%"
            style={{ height: '100%' }}
          />
        </div>
        <div className={styles.articlePreviewOverlay}></div>
        <div className={styles.titleContainer}>
          <div className={styles.articleDate}>{moment(article.publishDate).format("D MMMM YYYY")}</div>
          <h3 className={styles.previewTitle}>{article.title}</h3>
        </div>
        {/* <p
          dangerouslySetInnerHTML={{
            __html: article.description.childMarkdownRemark.html,
          }}
        /> */}
      </div>
    </Link>
  )
}
